var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 8.7912C11.9741 6.82187 11.2156 5.46046 10.8039 4.86436C10.698 4.71103 10.4719 4.73012 10.3898 4.898C10.2637 5.15585 10.0613 5.48182 9.78572 5.65149C9.78572 5.65149 8.61762 4.68502 8.56312 3.23711C8.55696 3.07186 8.39612 2.96018 8.24352 3.01339C7.62502 3.22935 6.31236 3.9548 5.99509 6.26609C5.7343 5.78417 5.11579 5.64338 4.71833 5.60376C4.55273 5.58718 4.41896 5.74432 4.46022 5.90981C4.76308 7.1241 4 7.84967 4 8.89309C4 11.1573 5.78473 12.9935 7.98855 13C10.2261 13.0065 12.0294 11.0882 11.9996 8.7912Z",
    fill: "url(#paint0_linear_985_10193)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_985_10193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9996 7.7912C12.9741 5.82187 12.2156 4.46046 11.8039 3.86436C11.698 3.71103 11.4719 3.73012 11.3898 3.898C11.2637 4.15585 11.0613 4.48182 10.7857 4.65149C10.7857 4.65149 9.61762 3.68502 9.56312 2.23711C9.55696 2.07186 9.39612 1.96018 9.24352 2.01339C8.62502 2.22935 7.31236 2.9548 6.99509 5.26609C6.7343 4.78417 6.11579 4.64338 5.71833 4.60376C5.55273 4.58718 5.41896 4.74432 5.46022 4.90981C5.76308 6.1241 5 6.84967 5 7.89309C5 10.1573 6.78473 11.9935 8.98855 12C11.2261 12.0065 13.0294 10.0882 12.9996 7.7912Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_985_10193",
    x: 2.7,
    y: -0.3,
    width: 12.6,
    height: 14.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_985_10193"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_985_10193",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_985_10193",
    x1: 12.6667,
    y1: 3,
    x2: 7.06359,
    y2: 14.4935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26B41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoost);
export default __webpack_public_path__ + "static/media/boost.b1691dee578c51ac2408c45386fd3271.svg";
export { ForwardRef as ReactComponent };